// extracted by mini-css-extract-plugin
module.exports = {"root":"m-multiplex__KHVS_tK"};